import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiResponse, HomePageModel, Product } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private http = inject(HttpClient);

    getHomeData(): Observable<HomePageModel> {
        return this.http.get<ApiResponse<HomePageModel>>('api/public/homepage').pipe(
            map((response) => {
                return response.data;
            }),
        );
    }

    getProductsByCategory(categoryName?: string): Observable<Product[]> {
        return this.http.get<ApiResponse<Product[]>>(`api/public/products?categories=${categoryName}`).pipe(map((response) => response.data));
    }
}
